import {
    adminclubConceptsHierarchyUrl,
    adminclubQuestionOfTheDayUrl,
    adminclubSeoForumUrl,
    adminclubTaggingForumUrl,
} from 'mk2/apps/adminclub/urls';
import { DynamicRoute } from 'mk2/containers/Application/Application';

export const routes: DynamicRoute[] = [{
    app: 'adminclub',
    exact: true,
    path: adminclubConceptsHierarchyUrl,
    getPage: () => {
        return import('mk2/apps/adminclub/containers/ConceptsHierarchy/ConceptsHierarchyPage' /* webpackChunkName: "adminclub.ConceptsHierarchy" */);
    },
    modules: [ 'mk2/apps/adminclub/containers/ConceptsHierarchy/ConceptsHierarchyPage' ],
}, {
    app: 'adminclub',
    exact: true,
    path: adminclubTaggingForumUrl,
    getPage: () => {
        return import('mk2/apps/adminclub/containers/SeoForum/SeoForumPage' /* webpackChunkName: "adminclub.SeoForum" */);
    },
    modules: [ 'mk2/apps/adminclub/containers/SeoForum/SeoForumPage' ],
}, {
    app: 'adminclub',
    exact: true,
    path: adminclubSeoForumUrl,
    getPage: () => {
        return import('mk2/apps/adminclub/containers/SeoForum/SeoForumPage' /* webpackChunkName: "adminclub.SeoForum" */);
    },
    modules: [ 'mk2/apps/adminclub/containers/SeoForum/SeoForumPage' ],
}, {
    app: 'adminclub',
    exact: true,
    path: adminclubQuestionOfTheDayUrl,
    getPage: () => {
        return import('mk2/apps/adminclub/containers/AdminclubQuestionOfTheDay/AdminclubQuestionOfTheDayPage' /* webpackChunkName: "adminclub.AdminclubQuestionOfTheDay" */);
    },
    modules: [ 'mk2/apps/adminclub/containers/AdminclubQuestionOfTheDay/AdminclubQuestionOfTheDayPage' ],
}];
